import React, { useEffect, useState } from "react";
import axios from "axios";
import * as API from "../../Endpoints/Endpoints";
import { useNavigate } from 'react-router-dom';

const ChariotTable = () => {
    const [data, setData] = useState([]);
    const [view, setView] = useState("global_ethics"); // Default to Global Ethics data
    const [searchTerm, setSearchTerm] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        fetchData(view);
    }, [view]);

    const fetchData = (type) => {
        const apiUrl = type === "global_ethics" ? API.GET_GLOBAL_ETHICS_API : API.GET_AI_CHARIOT_API;
        axios.get(apiUrl)
            .then(res => {
                console.log("Fetched Data:", res.data);
                setData(res.data);
            })
            .catch(err => {
                console.error("Error fetching data:", err);
                alert("Error fetching data: " + err);
            });
    };

    const handleUpload = (e) => {
        const file = e.target.files[0];
        console.log(file);
    
        if (file) {
            if (!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls')) {
                alert("Please upload an Excel file (xlsx or xls).");
                return;
            }
    
            const formData = new FormData();
            formData.append('file', file);
    
            axios.post(API.UPLOAD_CHARIOT_API, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                onUploadProgress: (progressEvent) => {
                    let percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                    console.log(`Upload progress: ${percent}%`);
                }
            }).then((res) => {
                alert("File uploaded and data added successfully");
                fetchData(view); // Refresh data after upload
            }).catch((err) => {
                console.error("Upload error:", err.response?.data || err.message);
                alert("Error uploading file: " + (err.response?.data?.message || err.message));
            });
        } else {
            alert("No file selected. Please choose a file to upload.");
        }
    };

    const DeleteChariot = (chariotid) => {
        if (window.confirm("Are you sure you want to delete this allocation?")) {
            axios({
                url: API.DELETE_ALLOCATION_API(chariotid),
                method: 'DELETE',
            }).then((res) => {
                alert("Deleted allocation successfully");
                fetchData();
            }).catch((err) => {
                alert("Error: " + err);
            });
        }
    };

    const DeleteGlobal = (globalid) => {
        if (window.confirm("Are you sure you want to delete this allocation?")) {
            axios({
                url: API.DELETE_ALLOCATION_API(globalid),
                method: 'DELETE',
            }).then((res) => {
                alert("Deleted allocation successfully");
                fetchData();
            }).catch((err) => {
                alert("Error: " + err);
            });
        }
    };

const ViewGlobal = (globalid) => {
    navigate(`/viewglobal/${globalid}`);
};

const ViewChariot = (chariotid) => {
    navigate(`/viewchariot/${chariotid}`);
};

const UpdateGlobal = (globalid) => {
    navigate(`/updateglobal/${globalid}`);
};

const UpdateChariot = (chariotid) => {
    navigate(`/updatechariot/${chariotid}`);
};
    
    return (
        <div className="p-4">
            <div className="flex gap-4 mb-4">
                <button className={`p-2 border ${view === "global_ethics" ? "bg-[#e64a32] text-white" : "bg-gray-200"}`} 
                        onClick={() => setView("global_ethics")}>
                    Global Ethics
                </button>
                <button className={`p-2 border ${view === "ai_career_chariot" ? "bg-[#e64a32] text-white" : "bg-gray-200"}`} 
                        onClick={() => setView("ai_career_chariot")}>
                    AI Career Chariot
                </button>
            </div>

            <div className="flex gap-4 mb-4"> <button className="bg-gray-200 text-black p-2 border " onClick={() => navigate("/addglobal")}>
                    Add Global Ethics
                </button>

                <button className="bg-gray-200 text-black p-2 border " onClick={() => navigate("/addchariot")}>
                    Add AI Chariot
                </button> </div>

           <div className="mt-2"> <input type="file" accept=".xlsx, .xls" onChange={handleUpload} className="mb-4" /> </div>

            <input 
                type="text" 
                placeholder="Search..."
                value={searchTerm} 
                onChange={(e) => setSearchTerm(e.target.value)} 
                className="p-2 border w-full mb-4"
            />

            <table className="border-collapse w-full mt-4">
                <thead>
                    <tr className="bg-[#e64a32] text-white">
                        <th className="border p-2">Chariot Name</th>
                        <th className="border p-2">Theme</th>
                        {view === "global_ethics" ? (
                            <>
                                <th className="border p-2">Religion</th>
                                <th className="border p-2">Wheel Number</th>
                                <th className="border p-2">Wheel Name</th>
                                <th className="border p-2">Moral Science Question</th>
                                <th className="border p-2">Age Group</th>
                                <th className="border p-2">Standard</th>
                                <th className="border p-2">Religious Quote</th>
                                <th className="border p-2">Action</th>
                            </>
                        ) : (
                            <>
                                <th className="border p-2">AI Career Role</th>
                                <th className="border p-2">Wheel Number</th>
                                <th className="border p-2">Wheel Name</th>
                                <th className="border p-2">Moral Science Question</th>
                                <th className="border p-2">Age Group</th>
                                <th className="border p-2">Standard</th>
                                <th className="border p-2">AI Insight</th>
                                <th className="border p-2">Action</th>
                            </>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {data
                        .filter(row => Object.values(row).some(value => value?.toString().toLowerCase().includes(searchTerm.toLowerCase())))
                        .map((row, index) => (
                            <tr key={index} className="border">
                                <td className="border p-2">{row.chariotname}</td>
                                <td className="border p-2">{row.theme}</td>
                                {view === "global_ethics" ? (
                                    <>
                                        <td className="border p-2">{row.religion}</td>
                                        <td className="border p-2">{row.wheelnumber}</td>
                                        <td className="border p-2">{row.wheelname}</td>
                                        <td className="border p-2">{row.moralsciencequestion}</td>
                                        <td className="border p-2">{row.agegroup}</td>
                                        <td className="border p-2">{row.standard}</td>
                                        <td className="border p-2">{row.religiousquote}</td>
                                        <td className="py-4 px-6 text-sm font-medium text-center text-gray-900 dark:text-white">
                                            <button onClick={() => ViewGlobal(row.globalid)} className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded-full ml-1">View</button>
                                            <button onClick={() => UpdateGlobal(row.globalid)} className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded-full ml-1 mt-2">Edit</button>
                                            <button onClick={() => DeleteGlobal(row.globalid)} className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded-full ml-1 mt-2">Delete</button>
                                        </td>
                                    </>
                                ) : (
                                    <>
                                        <td className="border p-2">{row.aicareerrole}</td>
                                        <td className="border p-2">{row.wheelnumber}</td>
                                        <td className="border p-2">{row.wheelname}</td>
                                        <td className="border p-2">{row.moralsciencequestion}</td>
                                        <td className="border p-2">{row.agegroup}</td>
                                        <td className="border p-2">{row.standard}</td>
                                        <td className="border p-2">{row.aiinsight}</td>
                                        <td className="py-4 px-6 text-sm font-medium text-center text-gray-900 dark:text-white">
                                        <button onClick={() => ViewChariot(row.chariotid)} className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded-full ml-1">View</button>
                                        <button onClick={() => UpdateChariot(row.chariotid)} className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded-full ml-1 mt-2">Edit</button>
                                        <button onClick={() => DeleteChariot(row.chariotid)} className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded-full ml-1 mt-2">Delete</button>
                                    </td>
                                    </>
                                )}
                            </tr>
                        ))}
                </tbody>
            </table>
        </div>
    );
};

export default ChariotTable;
